<dx-validation-group>
  <div class="messages">
    <div class="input-content">
      <dx-text-box
        label="Subject"
        stylingMode="filled"
        [(value)]="messageTitle"
      >
        <dx-validator>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
      <dx-text-area
        label="Message"
        stylingMode="filled"
        [(value)]="messageText"
        [height]="150"
      >
        <dx-validator>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-area>
      <dx-toolbar>
        <dxi-item location="before">
          <dx-file-uploader
            class="file-uploader"
            labelText=""
            [showFileList]="false"
            selectButtonText="Attach file"
          >
          </dx-file-uploader>
        </dxi-item>
        <dxi-item
          location="after"
          widget="dxButton"
          [options]="{
            text: 'Send',
            stylingMode: 'contained',
            type: 'default',
            onClick: send
          }"
        >
        </dxi-item>
      </dx-toolbar>
    </div>
    <div class="messages-content">
      <div class="message-list">
        <div class="message-container" *ngFor="let data of items">
          <user-avatar
            [dataLetters]="getAvatarText(data.manager)"
          ></user-avatar>
          <div class="message dx-card">
            <div class="message-title">
              <div>
                <div class="subject">{{ data.subject }}</div>
                <div>{{ data.date | date: 'MM/dd/y' }} - {{ data.manager }}</div>
              </div>
              <div>
                <dx-button icon="overflow" stylingMode="text"></dx-button>
              </div>
            </div>
            <div class="message-text">{{ getText(data) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</dx-validation-group>
